import { createTheme as createThemeBase, } from '@rneui/themed';
import deepmerge from 'deepmerge';
export * from './types';
import { theme as standard } from './standard';
export const createTheme = (options) => {
    const merged = deepmerge.all([
        standard,
        options,
    ]);
    const optionsKeys = Object.keys(options?.components || {});
    const optionComponents = options?.components;
    const mergedComponents = merged.components;
    for (let key of optionsKeys) {
        mergedComponents[key] = (props, theme) => {
            const standardComp = standard?.components?.[key];
            const optionalComp = optionComponents[key];
            return deepmerge.all([
                (typeof standardComp === 'function' ?
                    standardComp(props, theme) :
                    standardComp) || {},
                (typeof optionalComp === 'function' ?
                    optionalComp(props, theme) :
                    optionComponents) || {},
            ]);
        };
    }
    return createThemeBase(merged);
};
//# sourceMappingURL=index.js.map